import { gql } from "@apollo/client";

export const ETH_PRICE_QUERY = gql`
	query ethPrice {
		bundle(id: "1") {
			ethPrice
		}
	}
`
